import { useTRPCAPI, useTRPCQuery } from '../../../trpc/trpc';
import { useShareTokenInput } from './useShareTokenInput';

interface UsePlaylistFollowersTimeSeriesProps {
  playlistId: string;
  days?: number;
  endDate?: Date;
}

export const usePlaylistFollowersTimeSeries = ({
  playlistId,
  days = 30,
  endDate,
}: UsePlaylistFollowersTimeSeriesProps) => {
  const trpcMusicAPI = useTRPCAPI();
  const shareTokenInput = useShareTokenInput();

  return useTRPCQuery(
    trpcMusicAPI.playlists.followersTimeSeries.queryOptions(
      { playlistId, days, endDate, ...shareTokenInput },
      { enabled: Boolean(playlistId) }
    )
  );
};
